import type {ReactNode} from 'react';
import React from 'react';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';
import {AiChatLogo} from '@/ai-chat/components/ai-chat-logo/ai-chat-logo';
import styles from './ai-chat-mobile-nav.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {useTopBottomScrollShadowNonRef} from '@Hooks/useTopBottomScrollShadowNonRef';
import {AiChatAccountStatusBar} from '@Components/ai-chat-window/components/ai-chat-account-status-bar/ai-chat-account-status-bar';

export function AiChatMobileNav(): ReactNode {
  const {state, actions} = useAiChat();
  const messageContainer = document.getElementById('pmw-chat-messages-container');
  const {topShadow} = useTopBottomScrollShadowNonRef(messageContainer, !!messageContainer);
  const shouldShowBottomShadow = topShadow;
  const isUserLoggedIn = state.isUserLoggedIn;

  const getNewChatButtonForMobile = (): ReactNode => {
    if (!isUserLoggedIn) {
      return null;
    }

    return <Icon icon={'icon-plus'} className={styles.newChatIcon} onClick={onNewChat} size={IconSize.SIZE_ICON_20} type={IconType.GHOST_UNCOLORED} shape={IconShape.SQUARE} />;
  };

  const onNewChat = (): void => {
    actions.activateForNewChat();
    actions.setCurrentChatId(undefined);
    actions.setIsSidebarExpanded(false);
  };

  const getSeparator = (): ReactNode | null => {
    if (!isUserLoggedIn) {
      return null;
    }

    return <div className={styles.separator} />;
  };

  const getHeaderForMobile = (): ReactNode => {
    return (
      <div
        className={`
      _position-relative
      ${styles.aiChatMobileNav}
      flex-justify-between 
      ${shouldShowBottomShadow ? styles.bottomShadow : ''}
    `}
      >
        <AiChatLogo showHamburgerMenu={isUserLoggedIn} />

        <div className={`flexbox`}>
          <AiChatAccountStatusBar />
          {getSeparator()}
          {getNewChatButtonForMobile()}
        </div>
      </div>
    );
  };

  return getHeaderForMobile();
}
